/* eslint-disable no-undef */
// @flow
import React from 'react'
import PRListItem from './PRListItem/index'
import Checkbox from '../../../containers/shared/Checkbox'

type Props = {
  pullRequests: Array<Object>
}

type State = {
  open: boolean,
  closed: boolean
}

export default class PRList extends React.Component<Props, State> {
  state = {
    open: true,
    closed: false
  }

  toggle = (status: string) => {
    const newState = {}
    newState[status] = !this.state[status]
    this.setState(newState)
  }

  render () {
    const pullRequests = this.props.pullRequests
    const open = pullRequests.filter((pr) => pr.get('pr_status') === 'open').length
    const closed = pullRequests.filter((pr) => pr.get('pr_status') === 'closed').length
    const visiblePRs = pullRequests.filter((pr) => this.state[pr.get('pr_status')] === true).length

    return <div>
      <div className='flex-row'>
        <span style={{color: '#a6a6a6'}}>
          {`Listing ${visiblePRs} PR${visiblePRs === 2 ? '' : 's'}`}
        </span>
        <div style={{marginLeft: 'auto'}}>
          <div className='flex-row'>
            <Checkbox
              label='open'
              text={`Open (${open})`}
              isChecked={this.state.open}
              handleCheckboxChange={() => {
                this.toggle('open')
              }} />
            <Checkbox
              label='closed'
              text={`Closed (${closed})`}
              isChecked={this.state.closed}
              handleCheckboxChange={() => {
                this.toggle('closed')
              }} />
          </div>
        </div>
      </div>
      {
        pullRequests.map((pr, i) => {
          if (this.state[pr.get('pr_status')] === true) {
            return <PRListItem model={pr} key={i} />
          }
        })
      }
    </div>
  }
}

window.Components.PRList = React.createFactory(PRList)



// WEBPACK FOOTER //
// ./app/javascript/packs/components/project_dashboard/PRList/index.js